import React from "react";

// A single label/value pair inside a Bootstrap grid row
export default function DetailField({
  label,
  value,
  colClassName = "col-md-4 mb-2",
  detailsClassName = "customer-details",
  valueClassName,
}) {
  return (
    <div className={colClassName}>
      <div className={detailsClassName}>
        <h6>{label}</h6>
        <h5 className={valueClassName}>{value}</h5>
      </div>
    </div>
  );
}
